import $http from '@/plugins/axios'
import AppService from "src/services/app.service";

const ReportService = {
    SessionInfo(botCode, supporterEmail,timeType, fromDate, toDate, page=null, page_size=null) {
        if (supporterEmail && supporterEmail !== '') {
            return $http.get(`/live-support/session-report/${botCode}/${fromDate}/${toDate}/?supporter_email=${supporterEmail}&time_type=${timeType}&page=${page}&page_size=${page_size}`)
        } else {
            return $http.get(`/live-support/session-report/${botCode}/${fromDate}/${toDate}/?time_type=${timeType}&page=${page}&page_size=${page_size}`)
        }
    },
    SessionInfoExcel(botCode, supporterEmail,timeType, fromDate, toDate, crmExportFields, customerAttributes) {
        let body = {
            crm_export_fields: crmExportFields,
            customer_attributes: customerAttributes
        }
        if (supporterEmail && supporterEmail !== '') {
            return $http.post(`/live-support/session-report-excel/${botCode}/${fromDate}/${toDate}/?supporter_email=${supporterEmail}&time_type=${timeType}`, body)
        } else {
            return $http.post(`/live-support/session-report-excel/${botCode}/${fromDate}/${toDate}/?time_type=${timeType}`, body)
        }
    },
    SenderExcel(botCode, properties, customerAttributes) {
        let body = {
            properties: properties,
            customer_attributes: customerAttributes
        }
        return $http.post(`/live-support/sender-report-excel/${botCode}`, body)
        
    },
    SessionReportStatus(botCode) {
        return $http.get(`/live-support/session-report-status/${botCode}/`)
    },
    Categories(botCode) {
        return $http.get(`/live-support/report-categories/${botCode}/`)
    },
    Overview(botCode, channel, skills, fromDate, toDate) {
        let timeQuery = AppService.buildTimeQuery(fromDate, toDate);
        if (channel) {
            return $http.get(`/live-support/overview-report/${botCode}?channel=${channel}&skills=${skills}&${timeQuery}`)
        }
        else {
            return $http.get(`/live-support/overview-report/${botCode}?skills=${skills}&${timeQuery}`)
        }
    },
    MissChat(botCode, channel, skills, fromDate, toDate) {
        let timeQuery = AppService.buildTimeQuery(fromDate, toDate);
        if (channel) {
            return $http.get(`/live-support/miss-chat-report/${botCode}?channel=${channel}&skills=${skills}&${timeQuery}`)
        }
        else {
            return $http.get(`/live-support/miss-chat-report/${botCode}?skills=${skills}&${timeQuery}`)
        }
    },
    Ticket(botCode, status, keyword, fromDate, toDate, page=null, page_size=null) {
        let query = `page=${page}&page_size=${page_size}`;
        if (status && status !== '') {
            query = query + `&status=${status}`
        }
        if (keyword && keyword !=='') {
            query = query + `&keyword=${keyword}`
        }
        return $http.get(`/live-support/ticket-report/${botCode}/${fromDate}/${toDate}/?${query}`)
    },
    TicketReportExcel(botCode, status, keyword, fromDate, toDate) {
        let query = "";
        if (status && status !== '') {
            query = query + `&status=${status}`
        }
        if (keyword && keyword !=='') {
            query = query + `&keyword=${keyword}`
        }
        return $http.get(`/live-support/ticket-report-excel/${botCode}/${fromDate}/${toDate}/?${query}`)
    },
    TicketReportStatus(botCode) {
        return $http.get(`/live-support/ticket-report-status/${botCode}/`)
    },
}

export default ReportService
